import React from "react";
import {useSelector, useDispatch} from "react-redux";

import * as actionTypes from "../../../store/actions/actionTypes";

const AdmissionList_Item_Pdf = ({admission}) => {
    const idToken = useSelector(state => state.auth.idToken);
    const dispatch = useDispatch();
    const ref = React.useRef(null);

    // IMP-804 - per-hospital toggle: open documents in an in-browser modal
    // (with print) instead of downloading the file. Defaults to download.
    const useModal = admission.hospital && admission.hospital.manager_bulkDocumentsDownload_useModal;

    const downloadPdf = event => {
        event.preventDefault();
        event.stopPropagation();
        ref.current.submit();
    }

    const showModal = event => {
        event.preventDefault();
        event.stopPropagation();
        dispatch({type: actionTypes.MODAL_ADMISSION_BULK_PDF_SHOW, admission});
    }

    const handleClick = useModal ? showModal : downloadPdf;

    if (admission.haveDocuments) {
        return (
            <div className="documents-status done">
                <div className="doc pointer" onClick={handleClick}>
                    <i className="icon ico-document-with-conner"/>
                </div>
                {admission.isStatusPP_documentsMerged &&
                <div className="icon-check text-success pointer"  onClick={handleClick}>
                    <i className="icon ico-c-check"/>
                </div>
                }
                {!useModal &&
                <div className="display-none">
                    <form action={`${process.env.REACT_APP_API_PATH}/admission/${admission.id}/pdf`} method="post"
                          ref={ref}>
                        <input type="hidden" name="token" value={idToken}/>
                    </form>
                </div>
                }
            </div>
        );
    }

    return (
        <div className="documents-status n-a"  data-toggle="tooltip" data-placement="top" title="Select patient document set first">
            <div className="doc">
                <i className="icon ico-document-with-conner"/>
            </div>
            <div className="icon-check info-tooltip">
                <i className="icon ico-c-info" />
            </div>

        </div>
    );
}

export default AdmissionList_Item_Pdf;
